import {useMutation} from 'react-query';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
import PostViolationReportAdvertisement from '.';

interface IViolationReportProps {
  onSuccess?: () => void;
}

const usePostViolationReportAdvertisement = ({
  onSuccess,
}: IViolationReportProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IViolationReportAds) => {
      return PostViolationReportAdvertisement(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostViolationReportAdvertisement};
